import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Dashboard from './Pages/Dashboard';
import PackageInfo from './Pages/PackageInfo';
import DeveloperAccessPage from './Pages/DeveloperAccessPage';
import DetailsPage from './Pages/DetailsPage';
import VersionHistoryPage from './Pages/VersionHistory';
import Logout from './Pages/Logout';


const RouteConfig = () => {

  return (
    <Routes>
      <Route exact path="/" element={<Dashboard  />} />
      <Route exact path="/:id" element={<Dashboard  />} />
      <Route exact path="/package" element={<PackageInfo  />} />
      <Route exact path="/developer-access" element={<DeveloperAccessPage />} />
      <Route exact path="/store-listing/:id" element={<DetailsPage />} />
      <Route exact path="/approval" element={<VersionHistoryPage  />} />
      <Route exact path="/logout" element={<Logout />} />
    </Routes>

  );
};

export default RouteConfig;
